<template>
  <div id="mycontent">
    <Cover />
    <About />
  </div>
</template>

<script>
import Cover from "./mycomoponet/cover";
import About from "./mycomoponet/about";
export default {
  components: {
    Cover,
    About
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/pages/h5/home.vue